export type ChatDraftKind = "image" | "video" | "doc";

export interface ChatDraftAttachment {
  id: string;
  kind: ChatDraftKind;
  file: File;
  previewUrl: string;
  fileName: string;
  videoThumbnail?: string;
}

const DOC_EXT_RE =
  /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt|csv|rtf|odt|zip|rar|7z|gz|tar)$/i;

/** TEMP: mp3/audio attachable as doc draft; server coerces to voice bubble. */
const TEMP_AUDIO_EXT_RE = /\.(mp3|m4a|aac|ogg|wav|flac|opus)$/i;

function isDocMime(t: string): boolean {
  if (!t) return false;
  return (
    t === "application/pdf" ||
    t === "application/msword" ||
    t === "application/zip" ||
    t === "application/x-zip-compressed" ||
    t === "application/x-rar-compressed" ||
    t === "application/vnd.rar" ||
    t === "application/x-7z-compressed" ||
    t === "application/gzip" ||
    t === "application/x-tar" ||
    t === "application/x-gzip" ||
    t.includes("wordprocessingml") ||
    t.includes("spreadsheetml") ||
    t.includes("presentationml") ||
    t.startsWith("text/")
  );
}

function isTempVoiceAudioFile(file: File): boolean {
  const t = (file.type || "").toLowerCase();
  const name = file.name || "";
  if (t.startsWith("audio/")) return true;
  if (TEMP_AUDIO_EXT_RE.test(name)) return true;
  return false;
}

export function inferChatDraftKind(file: File): ChatDraftKind | null {
  const t = file.type || "";
  const name = file.name || "";
  if (t.startsWith("image/")) return "image";
  if (t.startsWith("video/")) return "video";
  // TEMP: pick mp3 via Document / drop → send as voice on server
  if (isTempVoiceAudioFile(file)) return "doc";
  if (isDocMime(t) || DOC_EXT_RE.test(name)) return "doc";
  // Empty MIME (some OS/browsers) — trust extension for archives/docs
  if (!t && DOC_EXT_RE.test(name)) return "doc";
  return null;
}
